import React, { useEffect, useRef } from 'react';
import { Modal, ModalBody } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { formatDateDDMMYY } from '../actions/commonActions';

const AdvertisementSlideShow = ({ showAllAdvt, setShowAllAdvt, activeAdvtSlideShowList }) => {
  const dispatch = useDispatch();

  const containerRef = useRef();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return; // Prevents the error

    let scrollSpeed = 1.5; // pixels per interval
    let interval;

    const startScrolling = () => {
      interval = setInterval(() => {
        container.scrollTop += scrollSpeed;
        if (container.scrollTop >= container.scrollHeight / 2) {
          container.scrollTop = 0;
        }
      }, 30);
    };

    const stopScrolling = () => clearInterval(interval);

    startScrolling();
    container.addEventListener("mouseenter", stopScrolling);
    container.addEventListener("mouseleave", startScrolling);

    return () => {
      stopScrolling();
      container.removeEventListener("mouseenter", stopScrolling);
      container.removeEventListener("mouseleave", startScrolling);
    };
  }, []);


  const handleModalClose = () => setShowAllAdvt(false);

  // Duplicate list for looping effect
  const adList = [...activeAdvtSlideShowList, ...activeAdvtSlideShowList];

  return (
    <div>
      {
        adList.length >= 1 &&
        <>
          {/* <div className='notice_div'>
          <h5 className='text-center notice'> {commonEnLabels.IMPORTANT_NOTICES} </h5>
          <button onClick={() => setShowAllAdvt(true)} > {commonEnLabels.VIEW_ALL_BTN} </button>
        </div> */}
          <div className="marquee" ref={containerRef}>
            <div>
              {adList.map((ad, idx) => (
                <div className='advt_div' key={idx}>
                  <h5 className='advt_name'>  Adv. No: {ad.advertisementNo}/{ad.year} -  {ad.name}</h5>
                  <p className='advt_lastdate'>Last date to apply :  {formatDateDDMMYY(ad.applnEndDate)}</p>
                </div>
              ))}
            </div>
          </div>
        </>
      }
      <div>
        <Modal show={showAllAdvt} onHide={handleModalClose} size='lg' backdrop="static" centered>
          <Modal.Header  className="advt-custom-modal-header logout_heading" >
            <Modal.Title className='logout_title'>
              All Active Advertisement Details
            </Modal.Title>
             <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={handleModalClose}
                    >X</button>
          </Modal.Header>
          <ModalBody>
            <div className="advt-table-scroll-container">
              <table>
                <thead>
                  <tr className='advt_table'>
                    <th className='advt_table_text sticky-header' >Advertisement Name</th>
                    <th className='advt_table_text sticky-header' >Last Date</th>
                  </tr>
                </thead>
                <tbody>
                  {activeAdvtSlideShowList.map((ele, i) => {
                    return <tr key={i}>
                      <td> Adv. No: {ele.advertisementNo}/{ele.year} -  {ele.name} <br /> {ele.nameDvng} </td>
                      {/* <td> 20/10/2002 </td> */}
                      <td className='w-15'> {formatDateDDMMYY(ele.applnEndDate)} </td>
                    </tr>
                  })}
                </tbody>
              </table>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default AdvertisementSlideShow;

